import React from "react";
import Layout from "../../components/Layout";
import { Table } from "react-bootstrap";

const Holidays = () => {
  return (
    <Layout>
      <div>
        <div className="d-flex justify-content-between align-items-center mb-3">
          <h3 className="mb-0">Holidays</h3>
        </div>
        <div className="card mb-4">
          <div className="card-body">
            <Table bordered responsive size="sm">
              <tbody>
                <tr>
                  <td>Wednesday 1 January - New Year's Day</td>
                </tr>
                <tr>
                  <td>Monday 27 January - Australia Day</td>
                </tr>
                <tr>
                  <td>Monday 10 March - Canberra Day</td>
                </tr>
                <tr>
                  <td>Friday 18 April - Good Friday</td>
                </tr>
                <tr>
                  <td>
                    Saturday 19 April - Easter Saturday - the day after Good
                    Friday
                  </td>
                </tr>
                <tr>
                  <td>Sunday 20 April - Easter Sunday</td>
                </tr>
                <tr>
                  <td>Monday 21 April - Easter Monday</td>
                </tr>
                <tr>
                  <td>Friday 25 April - Anzac Day</td>
                </tr>
                <tr>
                  <td>Monday 2 June - Reconciliation Day</td>
                </tr>
                <tr>
                  <td>Monday 9 June - King's Birthday</td>
                </tr>
                <tr>
                  <td>Monday 6 October - Labour Day</td>
                </tr>
                <tr>
                  <td>Thursday 25 December - Christmas Day</td>
                </tr>
                <tr>
                  <td>Friday 26 December - Boxing Day</td>
                </tr>
              </tbody>
            </Table>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default Holidays;
